import { Box, Button, Grid, TextareaAutosize, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

export default function QuestionsTextAreaArena251({ title }) {
	const theme = useTheme();
	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Grid
			xs={12}
			sx={{ paddingTop: 3 }}
		>
			<Typography
				variant={'h3'}
				fontFamily={'Poppins'}
				fontSize={'18px'}
				fontWeight={700}
				lineHeight={1.2}
				color={'#959595'}
			>
				{title}
			</Typography>
			<Box
				sx={{ borderRadius: '4px', marginY: 1, padding: '1px' }}
				className={'background-revalida-ldl'}
			>
				<TextField
					multiline
					rows={4}
					variant={'outlined'}
					style={{
						width: 'calc(100% - 1px)',
						minHeight: '82px',
						backgroundColor: '#151414',
						borderRadius: '4px',
					}}
				/>
			</Box>
			<Box
				sx={{
					width: '100%',

					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
				}}
			>
				<Button
					fullWidth={matchesMobile ? true : false}
					sx={{
						borderRadius: 32,
						paddingX: 5,
						fontFamily: 'Poppins',
						fontSize: '12px',
						color: 'white',
					}}
					className={'background-revalida-ldl'}
				>
					Enviar resposta
				</Button>
			</Box>
		</Grid>
	);
}
